import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { UserBulkCreation } from './features/UserBulkCreation';
import { UserBulkDeletion } from './features/UserBulkDeletion';
import { useUserList } from './hooks';
import { convertToPresentationProps, sortUploadStatusRows, sortUserRows } from './logics';
import { UserListPresentation } from './presentations';

/**
 * 利用者一覧 新UI Container
 *
 * 状態管理・アクションは useUserList に委譲し、API 型 → Presentation 型の変換は
 * convertToPresentationProps に委譲する。
 */
export const UserList: React.FC = () => {
  const {
    state: {
      unsetBranchUserCount,
      enableStaging,
      partnerFeatureFlagData,
      selectedTab,
      nameValue,
      emailValue,
      usersData,
      bulkCreationData,
      currentPage,
      totalPage,
      totalCount,
      uploadStatusCurrentPage,
      uploadStatusTotalPage,
      uploadStatusTotalCount,
      isBulkCreationModalOpen,
      isBulkDeletionModalOpen,
      usersSortState,
      uploadStatusSortState,
    },
    actions: {
      handleReload,
      handleTabChange,
      handleOpenBulkDeletionModal,
      handleCloseBulkDeletionModal,
      handleSuccessBulkDeletion,
      handleOutputCsv,
      handleOutputActivationCodeCsv,
      handleNavigateToUserNew,
      handleOpenBulkCreationModal,
      handleCloseBulkCreationModal,
      handleSuccessBulkCreation,
      handleNameChange,
      handleEmailChange,
      handleSearch,
      handleReset,
      handleDetailClick,
      handleSortUsers,
      handleEditUser,
      handleDeleteUser,
      handleCopyActivationCode,
      handlePageChange,
      handleSortUploadStatus,
      handleUploadStatusPageChange,
      handleCancelReservation,
    },
  } = useUserList();

  const {
    rows,
    uploadStatusRows,
    showScheduledAlert,
    showInternalColumns,
    showDownloadActivationCode,
  } = convertToPresentationProps({
    usersData,
    bulkCreationData,
    enableStaging,
    partnerFeatureFlagData,
  });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows,
    onPageChange: handlePageChange,
  });

  const uploadStatusPagerProps = generatePagerProps({
    currentPage: uploadStatusCurrentPage,
    totalPage: uploadStatusTotalPage,
    totalCount: uploadStatusTotalCount,
    rows: uploadStatusRows,
    onPageChange: handleUploadStatusPageChange,
  });

  const sortedRows = sortUserRows(rows, usersSortState);
  const sortedUploadStatusRows = sortUploadStatusRows(uploadStatusRows, uploadStatusSortState);

  return (
    <>
      <UserListPresentation
        unsetBranchUserCount={unsetBranchUserCount}
        showScheduledAlert={showScheduledAlert}
        onReloadForScheduledAlert={handleReload}
        selectedTab={selectedTab}
        onTabChange={handleTabChange}
        onOpenBulkDeletionModal={handleOpenBulkDeletionModal}
        onOutputCsv={handleOutputCsv}
        onOutputActivationCodeCsv={handleOutputActivationCodeCsv}
        onClickAddUser={handleNavigateToUserNew}
        onOpenBulkCreationModal={handleOpenBulkCreationModal}
        nameValue={nameValue}
        emailValue={emailValue}
        onNameChange={handleNameChange}
        onEmailChange={handleEmailChange}
        onSearch={handleSearch}
        onReset={handleReset}
        rows={sortedRows}
        onSortUsers={handleSortUsers}
        showInternalColumns={showInternalColumns}
        showDownloadActivationCode={showDownloadActivationCode}
        onDetailClick={handleDetailClick}
        onEditUser={handleEditUser}
        onDeleteUser={handleDeleteUser}
        onCopyActivationCode={handleCopyActivationCode}
        pagerProps={pagerProps}
        uploadStatusRows={sortedUploadStatusRows}
        onSortUploadStatus={handleSortUploadStatus}
        uploadStatusPagerProps={uploadStatusPagerProps}
        onCancelReservation={handleCancelReservation}
      />
      {isBulkCreationModalOpen && (
        <UserBulkCreation
          onClose={handleCloseBulkCreationModal}
          onSuccess={handleSuccessBulkCreation}
        />
      )}
      {isBulkDeletionModalOpen && (
        <UserBulkDeletion
          onClose={handleCloseBulkDeletionModal}
          onSuccess={handleSuccessBulkDeletion}
        />
      )}
    </>
  );
};
